import script from "./calendar-info.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-info.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__